import { Meta } from '@storybook/addon-docs';
import { TokensGrid } from '../../components/TokensGrid';
import { lineHeights } from '@rocketseat-ignite-ui/tokens';

<Meta title='Tokens/Line Heights' />

# Line Heights

<TokensGrid tokens={lineHeights} />
